<div class="flex">
  <div>
    <fcom-icon
      class="nordic-blue-900-text text-icon-primary icon-medium"
      *ngIf="icon"
      [name]="icon"
      [category]="category"
    />
  </div>
  <div class="flex-5 font-body-1 ps-xsmall-x font-body-medium">
    <ng-content />
  </div>
</div>
